export default __webpack_public_path__ + "static/med-melanie-bone-d65d87a71f12d67b433bfd27fc050672.png";